// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"cccd0e31","732":"f0b68464"}[chunkId] + ".chunk.js";
};